import { creatorbase } from '@round/api';
import { paymentProviderLabels } from 'Modules/Plans/helpers';
import PaymentProviderIcon from '../PaymentProviderIcon';
import styles from './PaymentProvider.module.css';

type Props = {
    paymentProvider: creatorbase.PaymentProvider;
};

const PaymentProvider = ({ paymentProvider }: Props) => {
    return (
        <div className={styles.container}>
            <PaymentProviderIcon paymentProvider={paymentProvider} variant="short" className={styles.icon} />
            <span>{paymentProviderLabels[paymentProvider]}</span>
        </div>
    );
};

export default PaymentProvider;
